import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'fileName', 'fileInput', 'clearButton', 'clearField' ]
  static values = {
    required: Boolean,
    fileName: String
  }

  updateFileName(event) {
    if (event.currentTarget.files.length > 0) {
      this.fileNameValue = event.currentTarget.files[0].name
    } else {
      this.fileNameValue = undefined
    }
  }

  fileNameValueChanged(fileName) {
    this.fileNameTarget.textContent = fileName
    if (!this.requiredValue) {
      if (this.hasFileNameValue) {
        this.clearButtonTarget.classList.remove('is-hidden')
        this.clearFieldTarget.disabled = true
      } else {
        this.clearFieldTarget.disabled = false
        this.clearButtonTarget.classList.add('is-hidden')
      }
    }
  }

  clear(event) {
    event.preventDefault()
    this.fileInputTarget.value = null
    this.fileInputTarget.dispatchEvent(new Event('change'))
  }
}
